import { render } from "./AssetLibrary.vue?vue&type=template&id=224ce0c2"
import script from "./AssetLibrary.vue?vue&type=script&lang=js"
export * from "./AssetLibrary.vue?vue&type=script&lang=js"

import "./AssetLibrary.vue?vue&type=style&index=0&id=224ce0c2&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__